import $ from 'jquery'
import { gsap } from 'gsap'

// ._animの付与処理をgsapタイムラインへ追加するための汎用関数
const addAnimToTimeLine = (timeline, selector, timing) => {
  timeline.call(
    () => {
      $(selector).addClass('_anim')
    },
    [],
    timing
  )
}

function init() {}
function ready() {
  // TOPページ MVエリア
  const topFirstViewAnimation = () => {
    if (!$('.js-top-header')[0]) return
    const fvTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.js-top-header',
        start: 'top center',
      },
    })

    addAnimToTimeLine(fvTl, '.js-top-lead-01', 0.2)
    addAnimToTimeLine(fvTl, '.js-top-lead-02', '>0.3')
    addAnimToTimeLine(fvTl, '.js-top-lead-03', '>0.4')
    addAnimToTimeLine(fvTl, '.js-top-img-wrap-01', '>0.8')
    addAnimToTimeLine(fvTl, '.js-top-img-01', '<')
    addAnimToTimeLine(fvTl, '.js-top-img-wrap-02', '>1')
    addAnimToTimeLine(fvTl, '.js-top-img-02', '<')
    addAnimToTimeLine(fvTl, '.js-top-news', '>0.6')
    addAnimToTimeLine(fvTl, '.js-top-future', '>0.6')
    addAnimToTimeLine(fvTl, '.js-top-future-text-01', '>0.6')
    addAnimToTimeLine(fvTl, '.js-top-future-text-02', '>0.8')
    addAnimToTimeLine(fvTl, '.js-top-future-text-03', '>1')
    addAnimToTimeLine(fvTl, '.js-top-info', '>0.8')
  }

  // 採用情報エリア
  const recruitmentAnimation = () => {
    if (!$('.js-top-recruitment')[0]) return
    const recTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.js-top-recruitment',
        start: 'top center',
      },
    })

    addAnimToTimeLine(recTl, '.js-top-recruitment-01', 0)
    addAnimToTimeLine(recTl, '.js-top-recruitment-02', '>0.2')
    addAnimToTimeLine(recTl, '.js-top-recruitment-03', '>0.4')
  }

  // 理念エリア
  const philosophyAnimation = () => {
    if (!$('.js-top-philosophy')[0]) return
    const phiTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.js-top-philosophy',
        start: 'top center',
      },
    })

    addAnimToTimeLine(phiTl, '.js-top-philosophy-01', 0)
    addAnimToTimeLine(phiTl, '.js-top-philosophy-02', '>0.2')
    addAnimToTimeLine(phiTl, '.js-top-philosophy-03', '>0.3')
    addAnimToTimeLine(phiTl, '.js-top-philosophy-01-img', '>0.35')
    addAnimToTimeLine(phiTl, '.js-top-philosophy-02-img', '>0.4')
    addAnimToTimeLine(phiTl, '.js-top-philosophy-03-img', '>0.45')
  }

  topFirstViewAnimation()
  recruitmentAnimation()
  philosophyAnimation()
}

export default {
  init() {
    init()
    $(function () {
      ready()
    })
  },
}
